import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Category } from './categories.models';

export const BookingSelectServicesCategoriesActions = createActionGroup({
  source: 'Booking Select Services',
  events: {
    'Load Categories': emptyProps(),
    'Component Loaded': emptyProps(),
  },
});

export const BookingSelectServicesCategoriesApiActions = createActionGroup({
  source: 'Booking Select Services API',
  events: {
    'Load Categories Success': props<{ categories: Array<Category> }>(),
    'Load Categories Failure': emptyProps(),
  },
});
